/* global __DivvyEnvironment */
// TODO: COM-7887 remove all instances of import React from 'react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'

import { initDatadog, rum } from '@divvy-web/utils.log'

import App from './App'
import { getEmailFromStorage, getEmailHashFromStorage } from './auth'
import { SputnikCanaryProvider } from './canary/SputnikCanaryProvider'

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@bdc-libs/trinity.scoped-custom-elements'

const shouldEnableMswMocking = async () => {
  /**
    UNCOMMENT THIS CODE IF YOU WANT TO USE MSW
    
    this is because I for the life of me cannot get MSW and webpack bundling
    to play along nicely together.
  */
  // if (process.env.MSW_ENABLED !== 'true') {
  //   return
  // }
  // const { worker } = await import('../testing/data/browser')
  // return worker.start({
  //   onUnhandledRequest: 'bypass',
  // })
}

initDatadog({
  clientToken: __DivvyEnvironment?.DATADOG_CLIENT_TOKEN || 'dd_client_token',
  env: __DivvyEnvironment.DATADOG_ENV ?? process.env.NODE_ENV,
  service: __DivvyEnvironment.DATADOG_SERVICE_ID,
})

rum.init({
  // Enabling Datadog actions will cause PII and credit card numbers
  // to be logged to Datadog RUM unless they are masked. Do not turn
  // on trackUserInteractions unless all PII and other sensitive info
  // is masked.
  trackUserInteractions: false,
  allowedTracingOrigins: ['https://apply.divvy.co', 'https://apply-stg.divvy.co'],
  applicationId: __DivvyEnvironment?.DATADOG_RUM_APPLICATION_ID,
  clientToken: __DivvyEnvironment?.DATADOG_RUM_CLIENT_TOKEN,
  defaultPrivacyLevel: 'mask',
  env: window.location.host.includes('apply-stg') ? 'stg' : __DivvyEnvironment?.DATADOG_ENV,
  premiumSampleRate: 5,
  sampleRate: 100,
  service: __DivvyEnvironment?.DATADOG_SERVICE_ID,
  sessionReplaySampleRate: 100,
  site: 'datadoghq.com',
  trackInteractions: true,
  trackLongTasks: true,
  trackResources: true,
  version: __DivvyEnvironment?.DEPLOY_VERSION,
})

const launchDarklyClientId = window.__DivvyEnvironment.LAUNCH_DARKLY_CLIENT_SIDE_ID
const disableLaunchDarkly = window.__DivvyEnvironment.DISABLE_LAUNCH_DARKLY

const emailHash = getEmailHashFromStorage() ?? 'anonymous-user'
const userEmail = getEmailFromStorage() ?? ''

const container = document.getElementById('react-app')
const root = createRoot(container)

if (disableLaunchDarkly === true || !launchDarklyClientId) {
  shouldEnableMswMocking().then(() =>
    root.render(
      <SputnikCanaryProvider>
        <App />
      </SputnikCanaryProvider>,
    ),
  )
} else {
  asyncWithLDProvider({
    clientSideID: launchDarklyClientId,
    deferInitialization: true,
    options: {},
    context: {
      kind: 'multi',
      creditApplicant: {
        key: emailHash,
        email: userEmail,
        _meta: {
          privateAttributes: ['/email'],
        },
      },
    },
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  }).then((LaunchDarklyProvider) => {
    root.render(
      <LaunchDarklyProvider>
        <SputnikCanaryProvider>
          <App />
        </SputnikCanaryProvider>
      </LaunchDarklyProvider>,
    )
  })
}
